<template>
  <div>
    <md-card>
      <md-card-content>
        <div id="pdfhtml">
          <article id="heading">
            <section style="visibility: hidden">
              <span>GlobeChek, LLC</span> <br />
              <span>1-877-GlobeChek</span> <br />
              <span>www.GlobeChek.com</span>
            </section>
            <section>
              <img alt="GlobeChek" src="/img/GlobeChek2.png" class="img-responsive" style="width: 150px;" />
            </section>
            <section>
              <span>GlobeChek, LLC</span> <br />
              <span>1-877-GlobeChek</span> <br />
              <span>www.GlobeChek.com</span>
            </section>
          </article>

          <br />

          <article id="member">
            <section>
              <dl id="info-screen">
                <dt>Name</dt>
                <dd>{{ preview.screenInfo.fullname }}</dd>
                <dt>Scan ID</dt>
                <dd>{{ preview.screenInfo.globeId }}-{{ preview.screenInfo.screeningID.slice(0, 8) }}</dd>
                <dt>Scan Date</dt>
                <dd>{{ getScreenDate }}</dd>
              </dl>
            </section>
            <section>
              <dl id="info-address">
                <dt>Address</dt>
                <br />
                <dd>
                  {{ preview.screenInfo.addressLn1 }}
                  {{ preview.screenInfo.addressLn2 }}
                </dd>
                <br />
                <dd>
                  {{ preview.screenInfo.city }},
                  {{ preview.screenInfo.state }}
                  {{ preview.screenInfo.zip }}
                </dd>
              </dl>
            </section>
            <section>
              <dl id="info-member">
                <dt>DOB</dt>
                <dd>{{ getDob }}&nbsp;({{ getAge }})</dd>
                <dt>Email</dt>
                <dd>{{ preview.screenInfo.email }}</dd>
                <dt>Cell</dt>
                <dd>{{ preview.screenInfo.cell }}</dd>
              </dl>
            </section>
          </article>

          <hr />

          <article id="screening">
            <section>
              <dl id="screening-title">
                <dt>&nbsp;</dt>
                <dt class="title">Vision without</dt>
                <dt class="spacer title">glasses:</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="title">Wavefront Auto</dt>
                <dt class="spacer title">Refraction:</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="title">Anterior Segment OCT:</dt>
                <dt class="spacer">&nbsp;</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="title">Intra Ocular:</dt>
                <dt>&nbsp;</dt>
              </dl>
            </section>
            <section>
              <dl id="screening-subtitle">
                <dt>&nbsp;</dt>
                <dt class="subhead">Right Eye:</dt>
                <dt class="spacer subhead">Left Eye:</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="subhead">Right Eye:</dt>
                <dt class="spacer subhead">Left Eye:</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="subhead">Right Eye:</dt>
                <dt class="spacer subhead">Left Eye:</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dt class="subhead">Right Eye:</dt>
                <dt class="subhead">Left Eye:</dt>
              </dl>
            </section>
            <section>
              <dl id="screening-col1">
                <dt class="heading">Distance VA</dt>
                <dd>{{ preview.visionInfo.acuityDist_OD }}</dd>
                <dd class="spacer">{{ preview.visionInfo.acuityDist_OS }}</dd>
                <!--SPACER-->
                <dt class="heading">Sphere</dt>
                <dd>{{ preview.visionInfo.autoRefOD_Sph }}</dd>
                <dd class="spacer">{{ preview.visionInfo.autoRefOS_Sph }}</dd>
                <!--SPACER-->
                <dt class="heading">Angle</dt>
                <dd>n/a</dd>
                <dd class="spacer">n/a</dd>
                <!--SPACER-->
                <dt class="heading">Eye Pressure</dt>
                <dd>{{ preview.visionInfo.eyePressure_OD }}</dd>
                <dd>{{ preview.visionInfo.eyePressure_OS }}</dd>
              </dl>
            </section>
            <section>
              <dl id="screening-col2">
                <dt class="heading">Near VA</dt>
                <dd>{{ preview.visionInfo.acuityNear_OD }}</dd>
                <dd class="spacer">{{ preview.visionInfo.acuityNear_OS }}</dd>
                <!--SPACER-->
                <dt class="heading">Cylider</dt>
                <dd>{{ preview.visionInfo.autoRefOD_Cyl }}</dd>
                <dd class="spacer">{{ preview.visionInfo.autoRefOS_Cyl }}</dd>
                <!--SPACER-->
                <dt class="heading">Thickness</dt>
                <dd>n/a</dd>
                <dd class="spacer">n/a</dd>
                <!--SPACER-->
                <dt class="heading">Corrected IOP</dt>
                <dd>&nbsp;</dd>
                <dd>&nbsp;</dd>
              </dl>
            </section>
            <section>
              <dl id="screening-col3">
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
                <dd class="spacer">&nbsp;</dd>
                <!--SPACER-->
                <dt class="heading">Axis</dt>
                <dd>{{ preview.visionInfo.autoRefOD_Axi }}</dd>
                <dd class="spacer">{{ preview.visionInfo.autoRefOS_Axi }}</dd>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
                <dd class="spacer">&nbsp;</dd>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
                <dd>&nbsp;</dd>
              </dl>
            </section>
            <section>
              <dl id="screening-col4">
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
                <dd>&nbsp;</dd>
                <dt class="spacer">&nbsp;</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dd><i>* Not valid for eye glasses</i></dd>
                <dd><i>prescription</i></dd>
                <dt class="spacer">&nbsp;</dt>
                <!--SPACER-->
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
                <dd>&nbsp;</dd>
                <dt class="spacer">&nbsp;</dt>
                <!--SPACER-->
              </dl>
            </section>
          </article>

          <hr />
          <br />
          <article id="photo">
            <section>
              <!--EXTERNAL & CORNEAL TOPOGRAPHY PHOTO -->
              <table class="report" style="width:100%">
                <tbody>
                  <tr align="right" style="line-height: 18px;">
                    <td class="label" align="left" colspan="2">
                      External Photo:
                    </td>
                    <td class="label" align="left" colspan="2">
                      Wavefront Corneal Topgraphy:
                    </td>
                  </tr>
                  <tr align="right" style="line-height: 18px;">
                    <td align="center" colspan="2">
                      <p class="field">&nbsp;</p>
                      <img :src="imgExt" class="img-responsive" alt="External Photo Image" style="width:400px;" />
                      <div
                        v-if="preview.extPhoto.diagOD.length > 0 || preview.extPhoto.diagOS.length > 0"
                        class="imgdiag"
                      >
                        <span v-if="preview.extPhoto.diagOD.length > 0"
                          ><b>OD</b>: {{ preview.extPhoto.diagOD.join(", ") }}</span
                        >
                        <br />
                        <span v-if="preview.extPhoto.diagOS.length > 0"
                          ><b>OS</b>: {{ preview.extPhoto.diagOS.join(", ") }}</span
                        >
                        <br />
                      </div>
                      <div v-else><p class="field">NORMAL</p></div>
                    </td>
                    <td align="center">
                      <p class="field">Right Eye</p>
                      <img
                        :src="imgCorOD"
                        class="img-responsive"
                        alt="Corneal Topography Right"
                        style="width: 400px;"
                      />
                      <div v-if="preview.corPhoto.diagOD.length > 0" class="imgdiag">
                        <span v-if="preview.corPhoto.diagOD.length > 0"
                          ><b>OD</b>: {{ preview.corPhoto.diagOD.join(", ") }}</span
                        >
                      </div>
                      <div v-else><p class="field">NORMAL</p></div>
                    </td>
                    <td align="center">
                      <p class="field">Left Eye</p>
                      <img :src="imgCorOS" class="img-responsive" alt="Corneal Topography LEFT" style="width:350px;" />
                      <div v-if="preview.corPhoto.diagOS.length > 0" class="imgdiag">
                        <span v-if="preview.corPhoto.diagOS.length > 0"
                          ><b>OS</b>: {{ preview.corPhoto.diagOS.join(", ") }}</span
                        >
                        <br />
                      </div>
                      <div v-else><p class="field">NORMAL</p></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section />
          </article>

          <hr />

          <article id="photo">
            <section>
              <dl id="photo-pacymetryOD">
                <dt>Anterior Segment OCT and Pachymetry:</dt>
                <dd>OD Diagnosis</dd>
              </dl>
            </section>

            <section>
              <dl id="photo-pacymetryOS">
                <dt>Anterior Segment OCT and Pachymetry:</dt>
                <dd>OS Diagnosis</dd>
              </dl>
            </section>
          </article>

          <hr />

          <article id="photo">
            <section>
              <dl id="photo-pacymetryOD">
                <dt>Anterior Segment OCT and Pachymetry:</dt>
                <dd>OD Diagnosis</dd>
              </dl>
            </section>
            <section>
              <dl id="photo-pacymetryOS">
                <dt>Anterior Segment OCT and Pachymetry:</dt>
                <dd>OS Diagnosis</dd>
              </dl>
            </section>
          </article>

          <hr />

          <article id="photo">
            <section>
              <dl id="photo-opacityOD">
                <dt>Lens Opacity / Cataract Grading:</dt>
                <dd>OD Diagnosis</dd>
              </dl>
            </section>
            <section>
              <dl id="photo-opacityOS">
                <dt>Lens Opacity / Cataract Grading:</dt>
                <dd>OS Diagnosis</dd>
              </dl>
            </section>
          </article>

          <hr />

          <article id="photo">
            <section>
              <dl id="photo-opacityOD">
                <dt>Retina and Optic Nerve:</dt>
                <dd>Fundus OD Diagnosis</dd>
              </dl>
            </section>
            <section>
              <dl id="photo-opacityOS">
                <dt>Retina and Optic Nerve:</dt>
                <dd>Fundus OS Diagnosis</dd>
              </dl>
            </section>
          </article>

          <hr />

          <article id="photo">
            <section>
              <dl id="photo-opacityOD">
                <dt>Macula (OCT):</dt>
                <dd>OD | OS Diagnosis</dd>
              </dl>
            </section>
            <section>
              <dl id="photo-opacityOS">
                <dt>Optic Nerve (OCT):</dt>
                <dd>OD | OS Diagnosis</dd>
              </dl>
            </section>
          </article>

          <hr />

          <div v-if="!isTeam()" style="margin-left: 30px; margin-right: 30px;" align="Left">
            <span>
              <h4><b>GlobeChek &trade;</b>&nbsp; Disclaimer:</h4>
            </span>

            <p style="margin-top: 5px;" align="Left">
              Your screening results were interpreted by a board-certified ophthalmologist or optometrist.
              <i>GlobeChek</i>&trade; recommends regular eye exams as directed by the
              <i>American Academy of Ophthalmology</i> as well as the <i>American Academy of Optometry</i>. Do not
              disregard professional medical advice or delay in seeking it because of this screen. If you believe you
              may have a medical emergency, call your doctor, visit an emergency care provider such as the emergency
              room of a nearby hospital, or call 911 immediately.
            </p>
          </div>
          <div v-else>
            <h4>JAGUARS-LOGO-GOES-HERE !!!!</h4>
            <img src="/img/JAGS_logo.png" class="img-responsive" alt="JAGUARS Logo" style="width: 175px" />
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment"
import { mapGetters } from "vuex"
export default {
  name: "ReportPreview",
  components: {},
  props: {
    firstProperty: {
      type: String,
      default: "Property One",
      required: false
    },
    secondProperty: {
      type: String,
      default: "Property Two",
      required: false
    }
  },
  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL
    }
  },
  computed: {
    ...mapGetters(["preview", "imagesPath"]),

    getDob: function() {
      return moment(this.preview.screenInfo.dob, "YYYY-MM-DDThh:mm:ss").format("l")
    },
    getAge: function() {
      return moment().diff(this.preview.screenInfo.dob, "years", false)
    },
    getScreenDate: function() {
      return moment(this.preview.screenInfo.scanDate, "MM/DD/YYYY").format("dddd MMMM Do, YYYY")
    },
    imgExt() {
      return this.imagesPath + "/" + this.preview.extPhoto.imgUrl
    },
    imgCorOD() {
      return this.imagesPath + "/" + this.preview.corPhoto.imgUrl_OD
    },
    imgCorOS() {
      return this.imagesPath + "/" + this.preview.corPhoto.imgUrl_OS
    },
    imgPacOD() {
      return this.imagesPath + "/" + this.preview.pacPhoto.imgUrl_OD
    },
    imgPacOS() {
      return this.imagesPath + "/" + this.preview.pacPhoto.imgUrl_OS
    },
    imgOpaOD() {
      return this.imagesPath + "/" + this.preview.opaPhoto.imgUrl
    },
    imgOpaOS() {
      return this.imagesPath + "/" + this.preview.opaPhoto.imgUrl
    },
    imgFunOD() {
      return this.imagesPath + "/" + this.preview.funPhoto.imgUrl_OD
    },
    imgFunOS() {
      return this.imagesPath + "/" + this.preview.funPhoto.imgUrl_OS
    },
    imgMacOD() {
      return this.imagesPath + "/" + this.preview.macPhoto.imgUrl_OD
    },
    imgMacOS() {
      return this.imagesPath + "/" + this.preview.macPhoto.imgUrl_OS
    },
    imgNrvOD() {
      return this.imagesPath + "/" + this.preview.nrvPhoto.imgUrl_OD
    },
    imgNrvOS() {
      return this.imagesPath + "/" + this.preview.nrvPhoto.imgUrl_OS
    },
    eval_comments() {
      var ext = this.preview.sumPara.diaSumExternal
      var ant = this.preview.sumPara.diaSumAnterior
      var pos = this.preview.sumPara.diaSumPosterior
      return "\t" + ext + "\n\n" + ant + "\n\n" + pos
    }
  },
  mounted: function() {
    const top = `<!DOCTYPE html><html lang="en"><head><link href="./rptAssets/css/reportDesign-view.css" rel="stylesheet" type="text/css"  /></head><body>`
    const bottom = `</body></html>`
    const reportHTML = top + document.querySelector("#pdfhtml").innerHTML + bottom

    //Call PDFFUnc with MASTER KEY
    var pdfFunc =
      "https://gcfunction.azurewebsites.net/api/CreatePDFfromHTML?code=iJgERugbMtZ31KAsy7Nl6mSSuhn6PrvNcaa1oM6ixtzZkDlNKB9keg==&pkg="

    var uri = pdfFunc + this.screeningID + ".html"
    var rptFile = new File([reportHTML], "../rptFile.html", {
      type: "text/html"
    })

    //-START DOWNLOAD RTPFILE HTML
    const mdata = rptFile
    const blob = new Blob([mdata], { type: "text/html" })
    const e = document.createEvent("MouseEvents"),
      a = document.createElement("a")
    a.download = "report.html"
    a.href = window.URL.createObjectURL(blob)
    a.dataset.downloadurl = ["text/html", a.download, a.href].join(":")
    e.initEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    a.dispatchEvent(e)
    //-END DOWNLOAD RTPFILE HTML
  },
  methods: {
    mouseOver: function() {},
    mouseLeave: function() {},

    isTeam: function() {
      if (
        process.env.VUE_APP_TITLE.substring(0, 5) == "BRAVE" ||
        process.env.VUE_APP_TITLE.substring(0, 5) == "JAGUA"
      ) {
        return true
      }
      return false
    },

    onPrint() {
      const top = `<!DOCTYPE html><html lang="en"><head><link href="./rptAssets/css/reportDesign-view.css" rel="stylesheet" type="text/css"  /></head><body>`
      const bottom = `</body></html>`
      const reportHTML = top + document.querySelector("#pdf").innerHTML + bottom

      //Call PDFFUnc with MASTER KEY
      var pdfFunc =
        "https://gcfunction.azurewebsites.net/api/CreatePDFfromHTML?code=iJgERugbMtZ31KAsy7Nl6mSSuhn6PrvNcaa1oM6ixtzZkDlNKB9keg==&pkg="

      var uri = pdfFunc + this.screeningID + ".html"
      var rptFile = new File([reportHTML], "../rptFile.html", {
        type: "text/html"
      })

      //-START DOWNLOAD RTPFILE HTML
      const mdata = rptFile
      const blob = new Blob([mdata], { type: "text/html" })
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a")
      a.download = "report.html"
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ["text/html", a.download, a.href].join(":")
      e.initEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
      //-END DOWNLOAD RTPFILE HTML

      const config = { headers: { "Content-Type": "application/json" } }
      const url = this.API_SERVICE + "/report-html"
      const data = {
        Id: sessionStorage.getItem("storageID"), //this.screeningID,
        reportHtml: reportHTML
      }

      window.axios
        .post(url, data, config)
        .then(function(response) {
          window.open(uri, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes")
        })
        .catch(function(error) {
          alert("PDF Creation Error: " + error)
        })
    }
  }
}
</script>

<style lang="css" scoped>
.md-card {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}
@charset "UTF-8";
@import url("https://fonts.googleapis.com/css?family=Roboto|Source+Sans+Pro:400,700");

@page {
    size: 8.50in 11.00in;
    margin: .4in .4in .4in .4in;
  @bottom-left {
    color: #1e5de4;
    font-family: Roboto;
    font-size: .8rem;
    font-style: italic;
    content: 'What we see may save your sight!';
    }

  @bottom-right {
    color: #a9a;
    font-family: Roboto;
    font-size: .75rem;
    content: 'info@globechek.com | 1-877-GlobeChek | www.GlobeChek.com';
    }
}

@media print {
    nav { display: none }
}

html {
  color: #14213d;
  font-family: Roboto;
  font-size: .8rem;
  /* line-height: 1.6; */
}

html body {
    margin: 0;
}

html h1 {
    color: #1e5de4;
    font-family: Roboto;
    font-size: 40pt;
    margin: 0;
}

html hr {
    /* border: none; */
    height: .5px;
    /* Set the hr color */
    color: #555; /* old IE */
    background-color: #555; /* Modern Browsers */
}

html body article#heading {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: .8rem;
    line-height: .95rem; }

    html body article#heading section span {
    font-size: .8rem;
    font-weight: 400;

    margin: 0 5px 0 0;  /* T R B L */
    padding: 0;
    text-align: left;
}


html body article#member {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: .8rem;
    line-height: 1.20rem; }

    html body article#member section dl {
        text-align: left;}

        html body article#member section dl dt, section dl dd {
          color: rgb(153, 159, 170);
          display: inline;
          margin: 0; }
        html body article#member section dl dt {
          color: rgb(38, 41, 46); }
        html body article#member section dl dt::before {
            content: '';
            display: block; }
        html body article#member section dl dt::after {
            content: ': '; }


html body article#screening {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: .75rem;
    line-height: 1.10rem; }

    html body article#screening section dl {
        text-align: left;}

        html body article#screening section dl dt, section dl dd {
            color: rgb(17, 70, 150);
            display: inline;
            margin: 0; }
        html body article#screening section dl dt {
            color: rgb(0, 0, 0); }
        html body article#screening section dl dt::before, html body article#screening section dl dd {
            content: '';
            display: block; }
        html body article#screening section dl dt::after {
            content: ''; }
        html body article#screening section dl dt.subhead {
            font-size: .65rem;
            color: rgb(102, 102, 128);
        }
        html body article#screening section dl dt.title {
            font-size: .75rem;
            font-weight: 500;
        }
        html body article#screening section dl dt.heading {
            font-size: .75rem;
            font-weight: 300;
            text-decoration: underline;
        }
        .spacer {
            margin-bottom: 5px;
        }
</style>
